import users from './users';
import admins from './admins';
import session from './session';
import live from './live';
import ticker from './ticker';
import prematch from './prematch';
import filters from './filters';
import subscription from './subscription';
import social from './social';
import data from './data';
import profiles from './profiles';
import forecast from './forecast';
import app from './app';
import company from './company';
import ads from './ads';

export default {
  ...session,
  app,
  profiles,
  prematch,
  users,
  admins,
  live,
  ticker,
  filters,
  subscription,
  social,
  data,
  forecast,
  company,
  ads,
  loadList: [],
};
